import React from 'react';

import Icon from '../Icon/Icon';

const SirenIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g stroke='#34303D' strokeWidth='2' fill='none' fillRule='evenodd' strokeLinecap='round'>
                <path d='M7 13.111c5.337 4.148 10.951 4.148 16.843 0 5.891-4.148 11.61-4.148 17.157 0M7 24c5.337 4.148 10.951 4.148 16.843 0 5.891-4.148 11.61-4.148 17.157 0M7 34.889c5.337 4.148 10.951 4.148 16.843 0 5.891-4.148 11.61-4.148 17.157 0' />
            </g>
        </Icon>
    );
};

export default SirenIcon;
